import axios from 'axios'
import { url } from './global'

export const getArticulosMasVendidos = async (
    fechad,
    fechah,
    sucursal,
    cliente,
    empleado,
    puntoVenta,
    facturada
) => {
    let token = sessionStorage.getItem('token')
    let headers = {
        'Content-Type': 'application/json',
        Authorization: 'Bearer '.concat(token),
    }
    let res = await axios.get(
        `${url}/v2/ventas/articulos-topten/fecha-desde/${fechad}/fecha-hasta/${fechah}?sucursal=${sucursal}&${cliente ? `cliente=${cliente}&` : ''}${empleado ? `empleado=${empleado}&` : ''}${puntoVenta ? `puntoVenta=${puntoVenta}&` : ''}${facturada ? `facturada=${facturada}` : ''}`,
        { headers }
    )
    return res
}

// REPORTE VENTAS BY MEDIO DE PAGOS // MONTOS
export const getVentaTotalByMediosPagos = async (
    fechaD,
    fechaH,
    sucursal,
    cliente,
    empleado,
    puntoVenta,
    facturada
) => {
    let token = sessionStorage.getItem('token')
    let headers = {
        'Content-Type': 'application/json',
        Authorization: 'Bearer '.concat(token),
    }
    let res = await axios.get(
        `${url}/v2/ventas/medios-pagos/fecha-desde/${fechaD}/fecha-hasta/${fechaH}?sucursal=${sucursal}&${cliente ? `cliente=${cliente}&` : ''}${empleado ? `empleado=${empleado}&` : ''}${puntoVenta ? `puntoVenta=${puntoVenta}&` : ''}${facturada ? `facturada=${facturada}` : ''}`,
        { headers }
    )
    return res
}

// REPORTE VENTAS POR ARTICULOS AGRUPADOS
export const getReporteVentasByArticulo = async (
    fechaD,
    fechaH,
    sucursal,
    cliente,
    empleado,
    puntoVenta,
    facturada
) => {
    let token = sessionStorage.getItem('token')
    let headers = {
        'Content-Type': 'application/json',
        Authorization: 'Bearer '.concat(token),
    }
    let res = await axios.get(
        `${url}/v2/ventas/reportes/articulos/fecha-desde/${fechaD}/fecha-hasta/${fechaH}?sucursal=${sucursal}&${cliente ? `cliente=${cliente}&` : ''}${empleado ? `empleado=${empleado}&` : ''}${puntoVenta ? `puntoVenta=${puntoVenta}&` : ''}${facturada ? `facturada=${facturada}` : ''}`,
        { headers }
    )
    return res
}

// REPORTE VENTAS TOTALES
export const getReporteVentasTotal = async (
    fechaD,
    fechaH,
    sucursal,
    cliente,
    empleado,
    puntoVenta,
    facturada
) => {
    let token = sessionStorage.getItem('token')
    let headers = {
        'Content-Type': 'application/json',
        Authorization: 'Bearer '.concat(token),
    }
    let res = await axios.get(
        `${url}/v2/ventas/reportes/totales/fecha-desde/${fechaD}/fecha-hasta/${fechaH}?sucursal=${sucursal}&${cliente ? `cliente=${cliente}&` : ''}${empleado ? `empleado=${empleado}&` : ''}${puntoVenta ? `puntoVenta=${puntoVenta}&` : ''}${facturada ? `facturada=${facturada}` : ''}`,
        { headers }
    )
    return res
}

// COMPRAS REPORTES V2
const compraReporteQuery = (sucursal, proveedor) =>
    `sucursal=${sucursal}${proveedor ? `&proveedor=${proveedor}` : ''}`

export const getReporteCompraResumen = async (
    fechaD,
    fechaH,
    sucursal,
    proveedor
) => {
    let token = sessionStorage.getItem('token')
    let headers = {
        'Content-Type': 'application/json',
        Authorization: 'Bearer '.concat(token),
    }
    let res = await axios.get(
        `${url}/v2/compras/reportes/resumen/fecha-desde/${fechaD}/fecha-hasta/${fechaH}?${compraReporteQuery(sucursal, proveedor)}`,
        { headers }
    )
    return res
}

export const getReporteCompraDeudasProveedor = async (
    fechaD,
    fechaH,
    sucursal,
    proveedor
) => {
    let token = sessionStorage.getItem('token')
    let headers = {
        'Content-Type': 'application/json',
        Authorization: 'Bearer '.concat(token),
    }
    let res = await axios.get(
        `${url}/v2/compras/reportes/deudas-proveedor/fecha-desde/${fechaD}/fecha-hasta/${fechaH}?${compraReporteQuery(sucursal, proveedor)}`,
        { headers }
    )
    return res
}

export const getReporteCompraArticulos = async (
    fechaD,
    fechaH,
    sucursal,
    proveedor
) => {
    let token = sessionStorage.getItem('token')
    let headers = {
        'Content-Type': 'application/json',
        Authorization: 'Bearer '.concat(token),
    }
    let res = await axios.get(
        `${url}/v2/compras/reportes/articulos/fecha-desde/${fechaD}/fecha-hasta/${fechaH}?${compraReporteQuery(sucursal, proveedor)}`,
        { headers }
    )
    return res
}

export const getReporteCompraDetalle = async (
    fechaD,
    fechaH,
    sucursal,
    proveedor
) => {
    let token = sessionStorage.getItem('token')
    let headers = {
        'Content-Type': 'application/json',
        Authorization: 'Bearer '.concat(token),
    }
    let res = await axios.get(
        `${url}/v2/compras/reportes/detalle/fecha-desde/${fechaD}/fecha-hasta/${fechaH}?${compraReporteQuery(sucursal, proveedor)}`,
        { headers }
    )
    return res
}

// STOCK BALANCE REPORT V2
const stockBalanceQuery = (sucursal, granularidad, nombre) =>
    `sucursal=${sucursal}&granularidad=${granularidad}${nombre ? `&nombre=${nombre}` : ''}`

export const getReporteStockBalance = async (
    fechaD,
    fechaH,
    sucursal,
    granularidad,
    nombre
) => {
    let token = sessionStorage.getItem('token')
    let headers = {
        'Content-Type': 'application/json',
        Authorization: 'Bearer '.concat(token),
    }
    let res = await axios.get(
        `${url}/v2/stocks/reportes/balance/fecha-desde/${fechaD}/fecha-hasta/${fechaH}?${stockBalanceQuery(sucursal, granularidad, nombre)}`,
        { headers }
    )
    return res
}

// STOCK CONCILIACION REPORT V2
export const CONCILIACION_UMBRAL_DEFAULT = 5
export const CONCILIACION_UMBRAL_OPTIONS = [1, 2, 5, 10, 20]

export const hasRequiredConciliacionFilters = ({
    fechaDesde,
    fechaHasta,
    sucursal,
}) => Boolean(fechaDesde && fechaHasta && sucursal)

export const canExportConciliacionExcel = (filas) =>
    Array.isArray(filas) && filas.length > 0

const conciliacionQuery = (sucursal, umbral, nombre) =>
    `sucursal=${sucursal}&umbral=${umbral}${nombre ? `&nombre=${nombre}` : ''}`

export const getReporteConciliacion = async (
    fechaD,
    fechaH,
    sucursal,
    umbral,
    nombre
) => {
    let token = sessionStorage.getItem('token')
    let headers = {
        'Content-Type': 'application/json',
        Authorization: 'Bearer '.concat(token),
    }
    let res = await axios.get(
        `${url}/v2/stocks/reportes/conciliacion/fecha-desde/${fechaD}/fecha-hasta/${fechaH}?${conciliacionQuery(sucursal, umbral, nombre)}`,
        { headers }
    )
    return res
}

// REPORTE VENTAS TOTALES BY CLIENTE AND MEDIO PAGO
export const getVentaTotalByClienteAndMedioPago = async (
    fechaD,
    fechaH,
    cliente
) => {
    let token = sessionStorage.getItem('token')
    let headers = {
        'Content-Type': 'application/json',
        Authorization: 'Bearer '.concat(token),
    }
    let res = await axios.get(
        `${url}/ventas/cliente/${cliente}/medios-pagos?fechaD=${fechaD}&fechaH=${fechaH}`,
        { headers }
    )
    return res
}
